import request from '@/utils/request'

export function list (data) {
  return request({
    url: 'api/MessageRetention/List',
    method: 'post',
    data
  })
}

export function info (id) {
  return request({
    url: 'api/MessageRetention/Info',
    method: 'get',
    params: { id }
  });
}

export function add (data) {
  return request({
    url: 'api/MessageRetention/Add',
    method: 'post',
    data
  })
}

export function update (data) {
  return request({
    url: 'api/MessageRetention/Update',
    method: 'post',
    data
  })
}

export function remove (id) {
  return request({
    url: 'api/MessageRetention/Delete',
    method: 'get',
    params: { id }
  })
}